export default {
	elevation: {
		key: 'elevation',
		name: 'Copernicus DEM 30m (GLO-30)',
		opacity: 0.8,
		options: {
			url: 'http://37.205.9.25:8080/geoserver/adbsam/wms',
			params: {
				layers: 'adbsam:drr_adbsam_glo30',
			},
		},
		type: 'wms',
	},
	height: {
		key: 'height',
		name: 'Height Above Nearest Drainage (HAND index)',
		opacity: 0.8,
		options: {
			url: 'http://37.205.9.25:8080/geoserver/adbsam/wms',
			params: {
				layers: 'adbsam:drr_adbsam_glo30_hand',
			},
		},
		type: 'wms',
	},
	slope: {
		key: 'slope',
		name: 'Slope',
		options: {
			url: 'http://37.205.9.25:8080/geoserver/adbsam/wms',
			params: {
				layers: 'adbsam:drr_adbsam_glo30_slope',
			},
		},
		type: 'wms',
	},
	refPoints: {
		key: 'refPoints',
		name: 'Reference point and permanent stations',
		options: {
			url: 'http://37.205.9.25:8080/geoserver/adbsam/wms',
			params: {
				layers: 'adbsam:drr_adbsam_refgpspnts',
			},
		},
		type: 'wms',
	},
	damSite: {
		key: 'damSite',
		name: 'ALAOA Dam site',
		options: {
			url: 'http://37.205.9.25:8080/geoserver/adbsam/wms',
			params: {
				layers: 'adbsam:drr_adbsam_alaoa',
			},
		},
		type: 'wms',
	},
};
